<template>
  <ButtonSnsSmall class="btn-sns--facebook" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-facebook-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--facebook {
  // 背景色がついているとborderのように表示され、白のfの文字に枠線がついてしまうので、transaparentを使用。
  @include bg-settings(
    '../../../../../../images/buttons/facebook-with-background.svg',
    transparent,
    100%,
    100%
  );
}
</style>
